import { css } from 'styled-components';

export const buttonHeight = 45;

const buttonStyles = css`
  --default-background: ${(props) => props.theme.brandPurple};
  --default-color: #ffffff;
  --hover-background: ${(props) => props.theme.brandDark};
  --hover-color: #ffffff;
  --disabled-background:#cccccc;
  --disabled-color: #666666;

  height: ${buttonHeight}px;
  background-color: var(--default-background);
  color: var(--default-color);
  display: inline-block;
  box-sizing: border-box;
  padding: 12px 30px;
  margin: 0;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;
  outline: 0;
  font-size: 14px;
  transition: background-color 0.5s, color 0.5s;
  text-align: center;
  font-weight: bold;

  i{
    color: inherit;
  }

  &:hover, &:focus-visible {
    background-color: var(--hover-background);
    color: var(--hover-color);
    text-decoration: none;
    outline: none;
  }
  &[disabled] {
    background-color: var(--disabled-background);
    color: var(--disabled-color);
    cursor: default;
  }
`;

export default buttonStyles;



// WEBPACK FOOTER //
// ./app/components/Button/buttonStyles.js